module.exports = __webpack_public_path__ + "static/media/trainVideo5.511bd422.mp4";